import axios from "axios";
import config from "@Config/index";

const getCustomPageData = async (partnerUuid: string) => {
  const url = `${config.API_URL}/api/v0/partner_custom_pages?partner_uuid=${partnerUuid}`;

  return axios.get(url, {
    withCredentials: true,
  });
};

export default getCustomPageData;
